import { CancelTokenSource } from 'axios';

import { TargetingCriterion } from '@/common/models';
import ExchangeAppAPIProxy from '@/exch-app/api';
import OrgAppAPIProxy from '@/org-app/api';
import { queryKeys } from '@/org-app/services/tanstack/queryKeys';
import { createGetAllQuery, isCuratorOrExchange } from '@/org-app/services/tanstack/queryUtils';
import orgAppStore from '@/org-app/store';
import { UPDATE_TARGETING_CRITERIA_LIST } from '@/org-app/store/modules/referenceData/mutation-types';

export const useTargetingCriteria = createGetAllQuery<TargetingCriterion>(
  [queryKeys.targetingCriteria],
  (cancelTokenSource: CancelTokenSource = null) =>
    isCuratorOrExchange()
      ? ExchangeAppAPIProxy.instance.getAllTargetingCriteria()
      : OrgAppAPIProxy.instance.getTargetingCriteria({ cancelTokenSource }),
  (data) => {
    orgAppStore.modules.ReferenceData.mutations[UPDATE_TARGETING_CRITERIA_LIST](
      orgAppStore.modules.ReferenceData.state,
      data,
    );
  },
);
